import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import {
  IndeedConfigurationModalDocument,
  JoinExternalIntegrationFragment,
  UpdateJoinCompanyNameDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  integrationProfile: JoinExternalIntegrationFragment
  onUpdated: () => void
  onClose: () => void
}

export const IndeedConfigurationModal = ({ integrationProfile, onUpdated, onClose }: Props) => {
  const { company } = useCurrentSession()

  const { data } = useQuery(IndeedConfigurationModalDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const [updateJoinCompanyName, { loading: updating }] = useMutation(
    UpdateJoinCompanyNameDocument,
    {
      extractorFn: (response) =>
        response.integrationsJoinMutations.updateIntegrationsjoinJoinCompany,
    }
  )

  const [indeedAccountName, setIndeedAccountName] = useState<string>(
    data?.integrationsJoin.joinCompaniesConnection.nodes[0]?.name ?? company.name
  )

  const handleUpdateJoinCompanyName = async () => {
    const result = await updateJoinCompanyName({
      variables: { companyId: company.id, name: indeedAccountName },
    })

    const handled = handleResult(result, () => undefined)

    if (handled?.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })

      onUpdated()
    }
  }

  return (
    <Modal title={integrationProfile.name} illustration="settings" onClose={onClose}>
      <Box gap="s16" alignItems="flexEnd" justifyContent="flexStart">
        <TextField
          label={i18n.t('ats.settings.job_promotions.external_profiles.indeed_form.title')}
          description={i18n.t(
            'ats.settings.job_promotions.external_profiles.indeed_form.description'
          )}
          value={indeedAccountName}
          placeholder={company.name}
          onChange={setIndeedAccountName}
        />
        <F0Button
          label={i18n.t('common.save')}
          onClick={handleUpdateJoinCompanyName}
          disabled={updating}
        />
      </Box>
    </Modal>
  )
}
